var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-page',[_c('v-container',[_c('div',{staticClass:"tit-wrap text-center"},[_c('h2',{staticClass:"tit tit--lg"},[_vm._v("경매약관")])]),_c('terms-component',{attrs:{"code":"auction"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }